/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { useQueryGetRefreshAndRetrieveUserConfiguration } from '@models';
import { AccessPermissions, RequestType, UserLoginDto } from '@types';

import { useOidc } from './OidcContext';

export const useRenewToken = () => {
    const oidcState = useOidc();
    if (!oidcState.isUserLoggedIn) {
        return () => Promise.resolve();
    }
    return oidcState.renewTokens;
};

export const useGetUserData = (): UserLoginDto | undefined =>
    useQueryGetRefreshAndRetrieveUserConfiguration({ staleTime: Infinity }).data;

/**
 * selector hooks
 */
export const useCurrentUser = () => useGetUserData();
export const useCurrentUserClient = () => useGetUserData()?.client;
export const useCurrentUserClientTimezone = () => useGetUserData()?.client?.timeZoneId || 'Europe/Paris';
export const useCurrentUserClientTrafficTypes = () => useGetUserData()?.client?.trafficTypes;
export const useCurrentUserResources = () => useGetUserData()?.client?.resources;
export const useCurrentUserProfilePermissions = () =>
    Array.from(useGetUserData()?.profile?.permissions || []) as AccessPermissions[];
export const useCurrentUserProfileRequestTypes = () =>
    Array.from(useGetUserData()?.profile?.requestTypes || []) as RequestType[];
export const useCurrentUserSettingsLanguage = () => useGetUserData()?.settings?.language;
